import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducers";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import localForge from "localforage/dist/localforage.js";
import { migrations } from "./reducers/cart";
import { asyncDispatchMiddleware } from "./asyncDispatchMiddleware";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "cart",
  version: 18,
  storage: localForge,

  migrate: createMigrate(migrations, { debug: false }),
  whitelist: [
    "cart",
    "customers",
    "PastOrders",
    "branch",
    "promise",
    "currency",
    "abandonedCart",
    // "productFilter",
  ],
};
const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk, asyncDispatchMiddleware))
);
const persistor = persistStore(store);

export { persistor, store };
